import { render } from "./product-grades.vue?vue&type=template&id=2a52f8fe"
import script from "./product-grades.vue?vue&type=script&lang=js"
export * from "./product-grades.vue?vue&type=script&lang=js"

import "./product-grades.vue?vue&type=style&index=0&id=2a52f8fe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__